import React, { Context, createContext, useContext } from "react";
import { UserClinicsClinics, UserRoles } from "fe-common/graphql";

export type UserClinic = {
  isFavorite: boolean;
} & UserClinicsClinics;

export type ClinicUserContextApi = {
  username: string;
  errMsg: string;
  isLoggedIn: boolean;
  isClinicUser: boolean;
  userClinics: UserClinic[];
  userRoles: UserRoles[];
  hasSuperAccess: boolean;
  hasAdminAccess: boolean;
  hasManagerAccess: boolean;
  loading: boolean;
  setUserClinics: React.Dispatch<React.SetStateAction<UserClinic[]>>;
  clearUser: () => void;
};
const ClinicUserContext: Context<ClinicUserContextApi> = createContext<
  ClinicUserContextApi
>({
  loading: true,
  isLoggedIn: false,
  isClinicUser: false,
  username: "",
  errMsg: "",
  userClinics: [],
  userRoles: [],
  hasSuperAccess: false,
  hasAdminAccess: false,
  hasManagerAccess: false,
  setUserClinics: () => {},
  clearUser: () => {},
});
export const useClinicUserContext = () => useContext(ClinicUserContext);

export const ClinicUserProvider = ({
  value,
  children,
}: {
  value: ClinicUserContextApi;
  children?: any;
}) => (
  <ClinicUserContext.Provider value={value}>
    {children}
  </ClinicUserContext.Provider>
);
